var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"relative"},[_c('div',{staticClass:"max-w-6xl mx-auto px-4 sm:px-6"},[_c('div',{staticClass:"py-12 md:py-16"},[_c('div',{staticClass:"max-w-4xl mx-auto text-center pb-12 md:pb-16"},[_c('h2',{staticClass:"h2 mb-4",attrs:{"data-aos":"zoom-y-out"}},[_vm._v(" Trusted by +6,000 teams all over the world ")])])])])])
}]

export { render, staticRenderFns }